import { render, staticRenderFns } from "./Light65GameBoy.vue?vue&type=template&id=1985493c&scoped=true&"
import script from "./Light65GameBoy.vue?vue&type=script&lang=js&"
export * from "./Light65GameBoy.vue?vue&type=script&lang=js&"
import style0 from "./Light65GameBoy.vue?vue&type=style&index=0&id=1985493c&lang=scss&scoped=true&"
import style1 from "./Light65GameBoy.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1985493c",
  null
  
)

export default component.exports